import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
  import router from "@/router";
  import { useStore } from "vuex";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LeaveWaitlistView',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const showError = ref(false);
  const isUnsubscribed = ref(false);
  const { email, estateTitle } = router.currentRoute.value.query;
  const subscriptionId = router.currentRoute.value.params.id;
  const loading = ref(true);

  const textDescription = {
    unsubscribe: `Are you sure you want to unsubscribe from the latest releases at ${decodeURIComponent(
      estateTitle
    )}?`,
    unsubscribed: "You've been successfully unsubscribed",
  };

  onMounted(() => {
    checkSubscription();
  });

  const checkSubscription = () => {
    store
      .dispatch("subscription/checkSubscription", subscriptionId)
      .then((res) => {
        if (!res.data?._id) {
          isUnsubscribed.value = true;
        }
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const unsubscribe = () => {
    loading.value = true;
    store
      .dispatch("subscription/deleteSubscription", subscriptionId)
      .then(() => {
        isUnsubscribed.value = true;
      })
      .catch(() => {
        showError.value = true;
      })
      .finally(() => {
        loading.value = false;
      });
  };

const __returned__ = { store, showError, isUnsubscribed, email, estateTitle, subscriptionId, loading, textDescription, checkSubscription, unsubscribe, ref, onMounted, get router() { return router }, get useStore() { return useStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})